
import { Component, Input, OnInit } from '@angular/core';
import { DownloadFileService } from '@shared/services/download-file.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({

  selector: 'file-download',
  templateUrl: 'file-download.component.html',
  styleUrls: ['./file-download.component.scss']
})
export class FileDownload implements OnInit {

  @Input() path:string;

  public inProgress:boolean = false;

  constructor(
    private sanitizer : DomSanitizer,
    private downloadFileService: DownloadFileService){
  }

  public download(){
    if(this.path){
    const name = this.path.split("/").pop();
    this.inProgress = true;
    this.downloadFileService.export(this.path).subscribe(
      data=>{
        this.inProgress = false;
        const  url = window.URL.createObjectURL(data);
        let a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.target = '_blank';
        a.download = name;
       
        const evt = new MouseEvent('click', {
            'view': window,
            'bubbles': true,
            'cancelable': false
        });
        a.dispatchEvent(evt);
        setTimeout(()=>{
          (window.URL).revokeObjectURL(a.href);
        },1);
    }, error=>{
      this.inProgress = true;
    });
    }
  }

  ngOnInit(){

  }

}

